import type { CustomerLastOrdered } from "@shared-core/data/customer-api-types";

// "You last ordered" when the viewer placed the order themselves; "Your company
// last ordered" for a colleague's order shown to a customer-wide viewer.
export function LastOrderedLine({
  lastOrdered,
}: {
  lastOrdered: CustomerLastOrdered;
}) {
  const who = lastOrdered.is_own_order ? "You" : "Your company";
  return (
    <p className="text-sm text-muted-foreground">
      {who} last ordered {lastOrdered.quantity.toLocaleString("en-GB")} on{" "}
      {formatOrderedOn(lastOrdered.ordered_on)}
    </p>
  );
}

// ordered_on is a calendar date (no time, no zone): build it from its parts in
// UTC so the viewer's timezone can never move it a day.
function formatOrderedOn(isoDate: string): string {
  const [year, month, day] = isoDate.split("-").map(Number);
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, day)));
}
